import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CardMarkerSmall from '../../../../../components/CockpitCards/CardMarkerSmall';
import DiaGetClockData from './DiaGetClockData';
import DiaClockInfo from './DiaClockInfo';
import GetAge from './GetAge';
import { useTheme } from "@mui/material";
import BioAgeSubCard from './BioAgeSubCard';
import PaceSubCard from './PaceSubCard';
import TelomereSubCard from './TelomereSubCard';


export default function ClockCard() {

  const theme = useTheme();
  
  const age = 61


return(
<>

{theme.palette.mode === "light" ? (

<CardMarkerSmall

headline = "BIOLOGICAL AGE" 
subtext = {"How old are you really? Biomarkers of aging and aging clocks are an essential part of aging research as aging is recognized as a fundamental driver of chronic diseases and mortality. Aging clocks are relatively new but groundbreaking in the aging science. Clocks not only tell you how old you really are (biological age versus chronological age), but also serve as monitor for the effectiveness of interventions in the aging process and preventive treatments for age-related diseases." }
  

list = { <DiaGetClockData /> }
info = { <DiaClockInfo /> }
addtextright = {<Typography variant="h6" gutterBottom sx={{fontWeight: 600, color: 'greydark.C100'}}> Chronological Age: {age} </Typography>}
cardlines = {<>

<Grid container spacing={2}>
<Grid size={12}>  <BioAgeSubCard /></Grid>
 <Grid size={12}> <PaceSubCard /></Grid>
   <Grid size={12}> <TelomereSubCard /></Grid>
</Grid>

</>}
/>  

) : (

  <CardMarkerSmall

headline = "BIO AGE" 
subtext = {"How old are you really? Biomarkers of aging and aging clocks are an essential part of aging research as aging is recognized as a fundamental driver of chronic diseases and mortality. Aging clocks are relatively new but groundbreaking in the aging science. Clocks not only tell you how old you really are (biological age versus chronological age), but also serve as monitor for the effectiveness of interventions in the aging process and preventive treatments for age-related diseases." }
  

list = { <DiaGetClockData /> }
info = { <DiaClockInfo /> }
addtextright = { <GetAge />   }
cardlines = {<>

<Grid container spacing={2}>
<Grid size={12}>  <BioAgeSubCard /></Grid>
 <Grid size={12}> <PaceSubCard /></Grid>
   <Grid size={12}> <TelomereSubCard /></Grid>
</Grid>

</>}
/>  

)}

</>
)
}

